/*
 * Portions of this code are from Novel (https://github.com/steven-tey/novel)
 * Copyright (c) 2023 Steven Tey
 * Licensed under the Apache License, Version 2.0
 */

import { useEditor } from '@/components/tiptap-editor'
import { cn } from '@/utils/cn'
import { Button } from '@blogging/ui'
import { SigmaIcon } from 'lucide-react'

export const MathSelector = () => {
  const { editor } = useEditor()

  if (!editor) return null

  return (
    <Button
      variant="ghost"
      size="sm"
      className="rounded-none w-12"
      onClick={(evt) => {
        if (editor.isActive('math')) {
          editor.chain().focus().unsetLatex().run()
        } else {
          const { from, to } = editor.state.selection
          const latex = editor.state.doc.textBetween(from, to)

          if (!latex) return

          editor.chain().focus().setLatex({ latex }).run()
        }
      }}
    >
      <SigmaIcon
        className={cn('size-4', { 'text-blue-500': editor.isActive('math') })}
        strokeWidth={2.3}
      />
    </Button>
  )
}
